import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js';

// Dependencies
import moment from 'moment';

// Components
import Drawer from '../Drawer/Drawer';
import SmarterFauxSelect from '../Common/SmarterFauxSelect';
import LoadMore from '../Common/LoadMore';

const Roster = observer(class Roster extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.syncEnrollments = this.syncEnrollments.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.getCourseRoster = this.getCourseRoster.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      query: '?limit=50&sortKeys=lastName&roles=learner&state=active',
      enrollmentSid: null,
      enrollmentName: null,
      fundingRuleSid: null,
      location: null,
      action: null,
      userSid: null
    };

    if(!this.props.installation) {
      // Get course enrollments
      this.getCourseRoster(this.state.query);

      // Also get course data so we can check enrollment sync
      this.props.store.SessionStore.getCourseData();
    } else {
      // Get installation users
      this.props.store.EnrollmentStore.getUsers();
    }
  }

  getCourseRoster(backgroundLoad) {
    const { EnrollmentStore } = this.props.store;

    if(this.state.query) {
      EnrollmentStore.getCourseRoster(this.state.query);
    } else {
      EnrollmentStore.getCourseRoster();
    }
  }

  syncEnrollments() {
    const { translation } = this.props;
    const { SessionStore, SyncStore } = this.props.store;

    const data = {
      type: 'enrollments',
      sid: SessionStore.userData.courseSid
    }

    const callback = () => {
      SessionStore.getCourseData(null, true);
      SessionStore.showToaster(translation.sync_scheduled, 'success');
    }

    SyncStore.scheduleSync(data, callback);
  }


  resetFilters(){
    const {EnrollmentStore} = this.props.store;

    EnrollmentStore.filterParams.fname  = '';
    EnrollmentStore.filterParams.lname = '';
    
    this.status.value = '';
    this.filter.value = '';
    let query = "?limit=50&sortKeys=lastName"

    this.setState({
      query
    }, function() {
      this.getCourseRoster();
    });
  }

  handleFilter(e) {
    const {EnrollmentStore} = this.props.store;

    e.preventDefault();
    let query = '';

    const fname = EnrollmentStore.filterParams.fname;
    const lname = EnrollmentStore.filterParams.lname;

    if(this.filter.value || this.status.value) {
      query = '?limit=50&sortKeys=lastName';
    }

    if(fname) {
      query += `&firstName=${fname}`;
    }

    if(lname) {
      query +=  `&lastName=${lname}`;
    }

    if(this.filter.value) {
      query += `&roles=${JSON.parse(this.filter.value).role}`;
    }

    if(this.status.value) {
      query += `&state=${this.status.value}`;
    }



    this.setState({
      query
    }, function(){
      this.getCourseRoster();
    });
  }

  selectOption(e, props) {
    const action = e.target.getAttribute('data-action');
    this.handleAction(e, action, props.enrollmentSid, props.userSid, props.studentName);
  }

  handleAction(e, action, enrollmentSid, userSid, studentName) {
    const drawerContent = action;
    const { SessionStore, SettingsStore, StudentStore } = this.props.store;
    let { pathname } = this.props.routing.location;

    this.setState({
      enrollmentSid,
      userSid
    })

    if(drawerContent && drawerContent !== 'LocateProctor' && drawerContent !== 'Impersonate') {
      toggleDrawer(e, this, drawerContent);
    }

    if(drawerContent === 'FundingRules') {
      this.setState({
        enrollmentName: studentName
      })
      pathname += `?fundingRuleScope=enrollmentSid&scopeSid=${enrollmentSid}`;
      this.props.routing.push(pathname);
    }

    if(drawerContent === 'LocateProctor') {
      // Get the student’s location
      SessionStore.getProfile(userSid, true, this, (e) => {toggleDrawer(e, this, drawerContent)});
    }

    // Open a new tab logged in as the student
    if(drawerContent === 'Impersonate') {
      let studentWindow = null;

      if(SessionStore.userData.role.toLowerCase() === 'instructor') {
        studentWindow = window.open('', '_blank');
      }

      StudentStore.impersonate(enrollmentSid, SettingsStore.integration.accessKey, studentWindow, userSid);
    }
  }

  deletionText(student) {
    const { translation } = this.props;

    let attempts = 0;
    let remaining = 4;
    let syncLabel = 'syncs';
    let remainingLabel = 'attempts';

    if(student.synchronization) {
      if(student.synchronization.failure1) {
        attempts += 1;
      }

      if(student.synchronization.failure2) {
        attempts += 1;
      }

      if(student.synchronization.failure3) {
        attempts += 1;
      }

      if(student.synchronization.failure4) {
        attempts += 1;
      }
    }

    remaining -= attempts;

    if(attempts === 1) {
      syncLabel = 'sync';
    }

    if(remaining === 1) {
      remainingLabel = 'attempt';
    }

    return translation.pending_deletion.helper
                      .replace('%attempts%', attempts)
                      .replace('%sync_label%', translation.pending_deletion[syncLabel])
                      .replace('%remaining%', remaining)
                      .replace('%attempt_label%', translation.pending_deletion[remainingLabel]);
  }

  renderResults() {
    const { EnrollmentStore, SessionStore } = this.props.store;
    const { translation } = this.props;

    // Roster actions
    const actions = [
      {
        title: translation.actions.search_proctors.label,
        action: 'LocateProctor',
        helper: translation.actions.search_proctors.helper
      }, {
        title: translation.actions.message_student.label,
        action: 'MessageThread',
        iamAction:'sp:DescribeMessageThreads',
        iamResource:[
          `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:message`
        ]
      }
    ]

    const impersonateAction = {
      title: translation.actions.impersonate.label,
      action: 'Impersonate',
      helper: translation.actions.impersonate.helper
    }

    actions.push(impersonateAction);

    if(SessionStore.userData.role.toLowerCase() === 'administrator') {
      const fundingRules = {
        title: translation.actions.funding_rule.label,
        action: 'FundingRules',
        helper: translation.actions.funding_rule.helper
      }

      actions.push(fundingRules);
    }

    if(EnrollmentStore.courseRoster.length > 0) {
      return(
        <table>
          <thead>
            <tr>
              <th id="heading-name" className="subtitle" scope="col">{translation.student}</th>
              <th id="heading-role" className="subtitle" scope="col">{translation.role}</th>
              <th id="heading-email" className="subtitle" scope="col">{translation.email}</th>
              <th id="heading-actions" className="subtitle table-action" scope="col">{translation.action}</th>
            </tr>
          </thead>
          <tbody>
            {EnrollmentStore.courseRoster.map(
              (key, i) =>
              <tr key={i}>
                <td aria-labelledby="heading-name">
                  {key.lastName}, {key.firstName}

                  {key.synchronization && key.synchronization.failure1 &&
                    <div className="tooltip">
                      <span
                        className="pill pill--negative tooltip__label"
                        aria-describedby="password-tooltip"
                      >
                        {translation.pending_deletion.label}
                      </span>

                      <div
                        id="password-tooltip"
                        className="tooltip__body"
                        role="tooltip"
                      >
                        {this.deletionText(key)}
                      </div>
                    </div>
                  }
                </td>
                <td aria-labelledby="heading-role" className="capitalize">{key.role}</td>
                <td aria-labelledby="heading-email"><a href={`mailto:${key.email}`}>{key.email}</a></td>
                <td aria-labelledby="heading-actions" className="actions">
                  {key.role.toLowerCase() === 'learner' &&
                    <div>
                      <SmarterFauxSelect
                        default={translation.action_select}
                        options={actions}
                        onClick={this.selectOption}
                        studentName={`${key.firstName} ${key.lastName}`}
                        enrollmentSid={key.enrollmentSid}
                        userSid={key.userSid}
                        parent={this}
                        skipText={true}
                        selectIndex={i}
                      />
                    </div>
                  }
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading && EnrollmentStore.courseRoster.length === 0) {
      let role = '';

      if(this.filter.value) {
        role = JSON.parse(this.filter.value).title;
      }

      return (
        <span className="no-results">
          {this.status.value &&
            translation.no_results_status.replace('%status%', this.status.value).replace('%role%', role)
          }

          {!this.status.value &&
            translation.no_results.replace('%role%', role)
          }
        </span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const {EnrollmentStore, SessionStore } = this.props.store;

    if(SessionStore.courseData) {
      const { synchronization } = SessionStore.courseData;

      return(
        <main tabIndex="0" id="main-content" className="page">
          <header className="page__header">
            <div className="wrap">
              <h1 className="page__title">{translation.page_title}</h1>
            </div>
          </header>

          <form className="filter" onSubmit={(e) => {this.handleFilter(e)}}>
            <div className="wrap">
              <fieldset>
                <ul className="fields fields--inline">
                  <li><legend>{translation.filters.label}:</legend></li>
                  <li>
                  <label className="meta" htmlFor="filter-fname">
                    {translation.fname}
                  </label>
                  <input
                    type="text"
                    id="filter-fname"
                    placeholder={translation.fname}
                    onChange={(e) => {EnrollmentStore.filterParams.fname = e.target.value}}
                    value={EnrollmentStore.filterParams.fname}

                  />
                </li>
                <li>
                  <label className="meta" htmlFor="filter-lname">
                    {translation.lname}
                  </label>
                  <input
                    type="text"
                    id="filter-lname"
                    placeholder={translation.lname}
                    onChange={(e) => {EnrollmentStore.filterParams.lname = e.target.value}}
                    value={EnrollmentStore.filterParams.lname}
                  />
                </li>
                  <li>
                    <label className="select">
                      <select
                        ref={(input) => {this.filter = input}}
                        defaultValue='{"role": "learner", "title": "learners"}'
                      >
                        <option value="">
                          {translation.filters.role.all}
                        </option>
                        <option value='{"role": "learner", "title": "learners"}'>
                          {translation.filters.role.learners}
                        </option>
                        <option value='{"role": "instructor", "title": "instructors"}'>
                          {translation.filters.role.instructors}
                        </option>
                        <option value='{"role": "administrator", "title": "administrators"}'>
                          {translation.filters.role.administrators}
                        </option>
                        <option value='{"role": "teachingAssistant", "title": "teaching assistants"}'>
                          {translation.filters.role.teaching_assistants}
                        </option>
                      </select>
                    </label>
                  </li>
                  <li>
                    <label className="select">
                      <select
                        ref={(input) => {this.status = input}}
                        //onChange={this.handleFilter}
                      >
                        {Object.keys(translation.filters.status).map(
                          (key) =>
                          <option value={key} key={key}>
                            {translation.filters.status[key]}
                          </option>
                        )}
                      </select>
                    </label>
                  </li>
                </ul>
              </fieldset>
              <div className="actions">
              <button
                className="btn"
                type="submit"
              >
                {translation.filter_button}
              </button>

              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.resetFilters}
              >
                {translation.reset}
              </button>
            </div>
            </div>
          </form>

          <div className="wrap">
            {/* Note if roster sync is not enabled */}
            {
              ((
                synchronization &&
                synchronization.enrollment &&
                !synchronization.enrollment.lastRun &&
                !synchronization.enrollment.nextRun
              ) || (
                synchronization && !synchronization.enrollment
              ) || !synchronization) &&

              <p className="note note--alt note--prominent">{translation.sync_not_active}</p>
            }

            <div className="page__data">
              {EnrollmentStore.rosterTotal >= 0 &&
                <span className="page__subheading">
                  {translation.total}: {EnrollmentStore.rosterTotal}
                </span>
              }

              {/* Show sync stats if they exist */}
              {
                synchronization &&
                synchronization.enrollment &&
                synchronization.enrollment.lastRun &&
                synchronization.enrollment.nextRun &&

                <div className="box box--right">
                  <p>
                    <span className="title">
                      {translation.last_sync}: {
                        moment.utc(synchronization.enrollment.lastRun)
                                        .local()
                                        .tz(moment.tz.guess())
                                        .format('M/D/YYYY [at] h:mma z')
                        }
                    </span>

                    <span className="title">
                      {translation.next_sync}: {
                        moment.utc(synchronization.enrollment.nextRun)
                                        .local()
                                        .tz(moment.tz.guess())
                                        .format('M/D/YYYY [at] h:mma z')
                        }
                    </span>

                    <button
                      className="btn--link"
                      onClick={this.syncEnrollments}
                    >
                      {translation.sync_now}
                    </button>
                  </p>
                </div>
              }
            </div>

            {this.renderResults()}

            <LoadMore
              url={EnrollmentStore.rosterNext}
              group={EnrollmentStore.courseRoster}
              text="Load more enrollments"
              store={EnrollmentStore}
              {...this.props}
            />
          </div>

          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this}
            single={true}
            enrollmentSid={this.state.enrollmentSid}
            location={this.state.location}
            fundingRuleSid={this.state.fundingRuleSid}
            enrollmentName={this.state.enrollmentName}
            preserveDrawer={true}
            searchForStudent={true}
            toUserSid={this.state.userSid}
            contextType="courseSid"
            contextId={SessionStore.courseData.sid}
            {...this.props}
          />
        </main>
      )
    }

    return null;
  }
})

export default translate('Roster')(Roster);



// WEBPACK FOOTER //
// ./src/app/components/Roster/Roster.js